import React from 'react';
import { Box, MenuItem, Select, TextField, FormControl, InputLabel, Stack, Typography } from '@mui/material';

function FillOptionsToolbar({ fillProps, setFillProps }) {
  const handleChange = (prop) => (event) => {
    setFillProps({ ...fillProps, [prop]: event.target.value });
  };

  const handleNumberChange = (prop) => (event) => {
    const val = parseFloat(event.target.value);
    setFillProps({ ...fillProps, [prop]: isNaN(val) ? 0 : val });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, padding: 1, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Fill:</Typography>
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <InputLabel>Type</InputLabel>
        <Select
          value={fillProps.type}
          label="Type"
          onChange={handleChange('type')}
        >
          <MenuItem value="solid">Solid</MenuItem>
          <MenuItem value="parallel">Parallel Lines</MenuItem>
        </Select>
      </FormControl>

      {fillProps.type === 'parallel' && (
        <Stack direction="row" spacing={1} alignItems="center">
          <TextField
            label="Spacing (d)"
            type="number"
            size="small"
            value={fillProps.spacing}
            onChange={handleNumberChange('spacing')}
            sx={{ width: 80 }}
            InputProps={{ inputProps: { min: 1 } }}
          />
          <TextField
            label="Segment (l)"
            type="number"
            size="small"
            value={fillProps.segmentLength}
            onChange={handleNumberChange('segmentLength')}
            sx={{ width: 80 }}
            InputProps={{ inputProps: { min: 1 } }}
          />
           <TextField
            label="Angle"
            type="number"
            size="small"
            value={fillProps.angle}
            onChange={handleNumberChange('angle')}
            sx={{ width: 80 }}
          />
        </Stack>
      )}
    </Box>
  );
}

export default FillOptionsToolbar;
